export class Address {
  id?: number;
  formattedAddress: string;
  streetNumber?: string;
  streetName?: string;
  city?: string;
  administrativeArea?: string;
  country?: string;
  postalCode?: string;
  latitude: number;
  longitude: number;
}
